import axios from 'axios';
import { BACKENDURL, retailerId } from './components/constants';

const axiosInstance = axios.create({
  baseURL: BACKENDURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  params: { 
    shopId: localStorage.getItem('shopId'), 
    retailerId: localStorage.getItem('retailerId'), 
    employee_id: localStorage.getItem('employeeId') 
  }
});

// Set token dynamically for each request
axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 419)) {
      // Clear all auth-related data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('shopId');
      localStorage.removeItem('employeeId');
      
      // Force full page reload to reset all state
      if (window.location.pathname !== '/login') {
        window.location.href = '/login?session_expired=true';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;